import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  getCountry(): Observable<any> {
    return of([]);
  }
}

export default CountryService;
